
// Configuration for API URL (matching api.js)
const normalizeApiUrl = (input) => {
    const fallback = '/api';
    const v = (input ?? '').toString().trim();
    if (!v) return fallback;

    if (v.startsWith('http://') || v.startsWith('https://')) {
        return v.replace(/\/+$/, '');
    }

    const withSlash = v.startsWith('/') ? v : `/${v}`;
    return withSlash.replace(/\/+$/, '');
};

const API_URL = normalizeApiUrl(process.env.REACT_APP_API_URL);

/**
 * Uploads a file to S3 using Presigned URLs generated by the Backend.
 * This removes the need for client-side credentials.
 */
export const uploadImageToS3 = async (file, folder = 'uploads/') => {
    if (!file) throw new Error("No file provided");

    try {
        // 1. Get Presigned URL from Backend
        // We prepend folder to filename to suggest path, though backend logic might override exact key structure
        const res = await fetch(`${API_URL}/upload-url`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                fileName: folder + file.name, // Pass folder preference in name if supported, or just name
                fileType: file.type
            })
        });

        if (!res.ok) {
            const errText = await res.text();
            throw new Error(`Failed to get upload URL: ${errText}`);
        }

        const { url: uploadUrl, key, publicUrl } = await res.json();

        // 2. Upload File to S3 via Presigned URL
        const uploadRes = await fetch(uploadUrl, {
            method: 'PUT',
            body: file,
            headers: {
                'Content-Type': file.type
            }
        });

        if (!uploadRes.ok) {
            throw new Error(`Failed to upload to S3: ${uploadRes.statusText}`);
        }

        // 3. Return Metadata matching existing interface
        return {
            url: publicUrl,
            key: key,
            bucket: 'managed-by-backend', // Placeholder as backend controls this
            region: 'managed-by-backend',
            uploadedAt: new Date().toISOString()
        };

    } catch (error) {
        console.error("Error uploading to S3 (Presigned):", error);
        throw error;
    }
};
